import Prospects from "./Pages/Prospects";

import { HiUserGroup } from "react-icons/hi";

let dashRoutes = [
  {
    path: "/prospects",
    name: "Prospects",
    icon: <HiUserGroup color="inherit" />,
    component: Prospects,
  },
];

export default dashRoutes;
